import ProgressError from './ProgressError';
class PropertyProgressIsNotRegistered extends ProgressError {
    propertyId;
    constructor(propertyId, options) {
        super('The crowdfunding property progress is not registered', options);
        this.propertyId = propertyId;
    }
}
export default PropertyProgressIsNotRegistered;
